import { EditorContent } from "@tiptap/react";
import StandaloneMathLive from "./StandaloneMathLive";
import useMathEditor from "./hooks/useMathEditor";
import Popup from "../../components/Popup";
import styles from "./mathEditor.module.css";

const MathEditor = (props) => {
  const { editorAttribs, popupAttribs, mathLiveAttribs, caretPosition } =
    useMathEditor(props);

  return (
    <div className={styles.mathEditor}>
      <Popup
        {...popupAttribs}
        expandRight
        isFixedPosition
        unpadded
        position={caretPosition}
      >
        <StandaloneMathLive {...mathLiveAttribs} />
      </Popup>
      <span
        className={styles.richTextEditor}
        style={{ opacity: props?.disabled ? "0.5" : "unset" }}
      >
        <EditorContent
          {...editorAttribs}
          style={{
            border: "1px solid #ccc",
            backgroundColor: "white",
            borderRadius: "6px",
            pointerEvents: props?.disabled ? "none" : "unset",
          }}
        />
      </span>
    </div>
  );
};

export default MathEditor;
